var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "panel-tag mt-2" }, [
      _vm._v("\n        " + _vm._s(_vm.__t("ATTACH_AUTO_DELIVERY")) + "\n    "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("yes_no", {
          key: "ENABLE_DELIVERY",
          attrs: { title: "ENABLE_DELIVERY" },
          on: { input: _vm.on_change_value },
          model: {
            value: _vm.enable_delivery,
            callback: function ($$v) {
              _vm.enable_delivery = $$v
            },
            expression: "enable_delivery",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.enable_delivery
      ? _c("div", { staticClass: "select_delivery_locations mb-5 pb-5" }, [
          _c("div", { staticClass: "form-group mt-5" }, [
            _c(
              "label",
              {
                staticClass: "form-label",
                attrs: { for: "shipping_delivery" },
              },
              [
                !_vm.is_rest_same
                  ? _c("sup", [
                      _c("span", { staticClass: "badge badge-danger ml-2" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.__t("REST_NOT_EQUAL")) +
                            "\n                    "
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.__t("DELIVERY_LOCATION")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            this.delivery_locations.length > 0
              ? _c(
                  "div",
                  {},
                  [
                    _c("v-select", {
                      staticClass: "imc_reasons",
                      attrs: {
                        id: "id",
                        label: "title",
                        reduce: function (item) {
                          return item.id
                        },
                        options: this.delivery_locations,
                        filterable: false,
                      },
                      on: { input: _vm.on_change_delivery_location },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "option",
                            fn: function (option) {
                              return [
                                _c("div", { staticClass: "d-center" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(option.title) +
                                      "\n                            "
                                  ),
                                  _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(option.uniq_id) +
                                        "\n                                "
                                    ),
                                    option.hasOwnProperty("linked_restaurant")
                                      ? _c("span", [
                                          option.linked_restaurant != null &&
                                          option.linked_restaurant.hasOwnProperty(
                                            "title"
                                          )
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      option.linked_restaurant
                                                        .title
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2825987854
                      ),
                      model: {
                        value: _vm.active_location,
                        callback: function ($$v) {
                          _vm.active_location = $$v
                        },
                        expression: "active_location",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "payments_filter" }, [
              _c("div", { staticClass: "form-group mt-2" }, [
                _c(
                  "label",
                  {
                    staticClass: "form-label",
                    attrs: { for: "advanced_name" },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.__t("DELIVERY.FILTER_PAYMENTS")) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group flex-nowrap" },
                  [
                    _c("b-form-radio-group", {
                      attrs: {
                        id: "btn-radios-1",
                        "button-variant": "outline-primary",
                        options: _vm.payments_filter_options,
                        name: "radios-btn-default",
                        buttons: "",
                      },
                      on: { change: _vm.on_change_payments },
                      model: {
                        value: _vm.filter_payment,
                        callback: function ($$v) {
                          _vm.filter_payment = $$v
                        },
                        expression: "filter_payment",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }